import { mapDTO } from '@twistezo/ts-dto-mapper'

import { UserSlice, UserSliceDTO } from 'features/user/forms/UserEmployeeForm/types'

export const userFromDTO = (from: UserSliceDTO): UserSlice =>
  mapDTO<UserSliceDTO, UserSlice>({ from }).transform(user => user)
